import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=14918391&"
import script from "./FooterCopyright.vue?vue&type=script&lang=js&"
export * from "./FooterCopyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports